import React from 'react';
import { connect } from 'react-redux';

import { Table } from 'reactstrap';
import './styles.scss';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';
import { MOMENT } from '@reducers/units';

const CalculateInstallationData = props => ( // eslint-disable-line
  <div className="calculation">
    <section className="list-type calculate-installation-data">
      <Table bordered size="sm">
        <tbody>
          {props.installationData.map(item => {
            return item.IsVisible && (
              <tr key={item.StringValue + item.Value + item.Label}>
                <th scope="row">{item.Label}</th>
                <td>{getValue(item, props, item.InternalName === "Tightening_torque" ? defaultUnits.MOMENT : defaultUnits.DISTANCE)}</td>
                <td>
                  {!item.InternalName.startsWith("Fixings_per_cartridge") && 
                    (item.InternalName === "Tightening_torque" ? 
                      unitLabel(props.momentUnit === MOMENT.FOOT_POUND_FORCE ? MOMENT.FOOT_POUND_FORCE : MOMENT.NEWTON_METERS) : 
                      unitLabel(props.distanceUnit))}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {props.installationDataLastItem && props.installationDataLastItem.IsVisible && (
        <Table bordered size="sm">
          <tbody>
            <tr>
              <th scope="row">{props.installationDataLastItem.Label}</th>
              <td className={props.installationDataLastItem.InternalName === "Cleaning" ? "w-75" : undefined}>
                {
                  props.installationDataLastItem.StringValue === null ?
                    props.installationDataLastItem.Value :
                    props.installationDataLastItem.StringValue
                }
              </td>
              <td></td>
            </tr>
          </tbody>
        </Table>
      )}
    </section>
  </div>
);

function getValue(item, props, unit) {
  let toUnit;
  if (unit === defaultUnits.MOMENT)
    toUnit = props.momentUnit === MOMENT.FOOT_POUND_FORCE ? MOMENT.FOOT_POUND_FORCE : MOMENT.NEWTON_METERS;
  else 
    toUnit = props.distanceUnit;

  if (item.StringValue === null) {
    if (Number.isFinite(+item.Value)) {
      return unitTransform(+item.Value).from(unit).to(toUnit);
    } else {
      return item.Value;
    }
  } else {
    if (Number.isFinite(+item.StringValue)) {
      return unitTransform(+item.StringValue).from(unit).to(toUnit);
    } else if (Number.isFinite(+item.Value)) {
      return unitTransform(+item.Value).from(unit).to(toUnit);
    } else {
      return item.Value;
    }
  }
}

const mapState = state => {
  const arr = state.selectors.calculate[state.main.appType].installationData || [];

  return {
    installationData: arr.slice(0, -1),
    installationDataLastItem: arr.slice(-1)[0],
    distanceUnit: state.main.units.distance,
    momentUnit: state.main.units.moment
  };
};

export default connect(mapState)(CalculateInstallationData);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateInstallationData/index.js